var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareMarkdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81885 8.16089C6.81885 7.73684 7.11351 7.39307 7.47699 7.39307H14.6675C15.031 7.39307 15.3256 7.73684 15.3256 8.16089C15.3256 8.58494 15.031 8.92871 14.6675 8.92871H7.47699C7.11351 8.92871 6.81885 8.58494 6.81885 8.16089ZM6.81885 12C6.81885 11.5759 7.11351 11.2322 7.47699 11.2322H16.523C16.8865 11.2322 17.1811 11.5759 17.1811 12C17.1811 12.4241 16.8865 12.7678 16.523 12.7678H7.47699C7.11351 12.7678 6.81885 12.4241 6.81885 12ZM7.47699 15.0713C7.11351 15.0713 6.81885 15.415 6.81885 15.8391C6.81885 16.2632 7.11351 16.6069 7.47699 16.6069H12.0879C12.4513 16.6069 12.746 16.2632 12.746 15.8391C12.746 15.415 12.4513 15.0713 12.0879 15.0713H7.47699Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMarkdown);
export default __webpack_public_path__ + "static/media/square_markdown.98a6bb9afe9d78659c741c5dffc1823f.svg";
export { ForwardRef as ReactComponent };